import React from "react"
import ContentTransformer from "../Transformers/content-transformer"
import {
  teleformContainer,
  teleformulaire,
  teleformTitle,
  teleformTaxo,
  teleformTaxoItem,
  teleformFooter,
  teleformFooterDate,
  teleformLinks,
  teleformLinksItem,
  teleformLinksList,
  teleformLinksTitle,
  teleformLinksItemTitle,
  teleformLibre,
} from "./teleformulaire.module.scss"
import PropTypes from "prop-types"
import {
  Title,
  SubTitle,
  TaxoButton,
  StyledFooter,
} from "./teleformulaire-styled"
import TransitionFade from "../transition-fade"
import FadeIn from "react-fade-in"

//-----------------------Parent component---------------------------//

const Teleformulaire = ({ teleform, zoneLibre }) => {
  return (
    <FadeIn delay={150}>
      <section className={zoneLibre ? teleformLibre : teleformContainer}>
        <TeleformHeader teleform={teleform} />
        <TeleformLinks teleform={teleform} />
        {!zoneLibre && <TeleformFooter teleform={teleform} />}
      </section>
    </FadeIn>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component/Header---------------------------//

const TeleformHeader = ({ teleform }) => (
  <article className={teleformulaire}>
    <Title className={teleformTitle}>{teleform.title}</Title>
    {teleform.relationships.field_taxonomie_teleformulaire?.length > 0 && (
      <div className={teleformTaxo}>
        {teleform.relationships.field_taxonomie_teleformulaire.map((taxo) => (
          <TaxoButton key={taxo.name} className={teleformTaxoItem}>
            <TransitionFade link={taxo.path.alias}>{taxo.name}</TransitionFade>
          </TaxoButton>
        ))}
      </div>
    )}
    {teleform.body && <ContentTransformer content={teleform.body.processed} />}
  </article>
)

//-----------------------Child component/Header---------------------------//

//-----------------------Child component/Links---------------------------//

const TeleformLinks = ({ teleform }) => {
  return (
    <div className={teleformLinks}>
      <SubTitle className={teleformLinksTitle}>
        Liens démarches simplifiées
      </SubTitle>
      <ul className={teleformLinksList}>
        {teleform.field_lien_demarches_simplifiees?.length > 0 && (
          <>
            {teleform.field_lien_demarches_simplifiees.map((link) => (
              <li key={link.title} className={teleformLinksItem}>
                <a target="_blank" rel="noopener noreferrer" href={link.uri}>
                  <p className={teleformLinksItemTitle}>{link.title}</p>
                </a>
              </li>
            ))}
          </>
        )}
      </ul>
    </div>
  )
}

//-----------------------Child component/Links---------------------------//

//-----------------------Child component/Footer---------------------------//

const TeleformFooter = ({ teleform }) => (
  <StyledFooter className={teleformFooter}>
    <div className={teleformFooterDate}>posté le {teleform.created}</div>
  </StyledFooter>
)

//-----------------------Child component/Footer---------------------------//

//-----------------------Prop-Types---------------------------//

Teleformulaire.propTypes = {
  teleform: PropTypes.object.isRequired,
  zoneLibre: PropTypes.bool,
}
TeleformHeader.propTypes = {
  teleform: PropTypes.object.isRequired,
  colors: PropTypes.object,
}
TeleformLinks.propTypes = {
  teleform: PropTypes.object.isRequired,
  colors: PropTypes.object,
}
TeleformFooter.propTypes = {
  teleform: PropTypes.object.isRequired,
  colors: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default Teleformulaire
